export default function (str) {
  return str.split(",").reduce((p, c, i, a) => {
    p[c] = true
    return p
  }, {})
}


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/dinnerSvg/parser/makeLookup.js